// // import React, { useEffect } from 'react';
// // import { Card, Container, Row, Col } from 'react-bootstrap';
// // import { useSelector, useDispatch } from 'react-redux';
// // import { fetchAllUsers } from '../../redux/slices/UsersSlice';
// // import { fetchAllDevices } from '../../redux/slices/DeviceSlice';
// // import { fetchAllAdmins } from '../../redux/slices/AdminSlice';
// // import { fetchAllPatients } from '../../redux/slices/PatientSlice';
// // import { fetchAllAlerts } from '../../redux/slices/AlertSlice';
// // import PatientLookup from '../Admin/PatientLookup';
 
// // const AdminCards = ({ onNavigate }) => {
// //   const dispatch = useDispatch();
 
// //   // Fetch data from Redux store
// //   const { users } = useSelector((state) => state.users);
// //   const { devices } = useSelector((state) => state.devices);
// //   const { admins } = useSelector((state) => state.admins);
// //   const { notifications } = useSelector((state) => state.notifications);
// //   const { patients } = useSelector((state) => state.patients);
// //    const { alerts, loading: alertsLoading } = useSelector((state) => state.alerts);
 
// //   useEffect(() => {
// //     dispatch(fetchAllUsers());
// //     dispatch(fetchAllDevices());
// //     dispatch(fetchAllAdmins());
// //     dispatch(fetchAllPatients());
// //     dispatch(fetchAllAlerts()); // fetch alerts to get count
// //   }, [dispatch]);
 
// //   const userCount = users.length;
// //   const deviceCount = devices.length;
// //   const activeAlertsCount = notifications.length;
// //   const adminCount = admins.length;
// //   const patientCount = patients.length;
 
// //   return (
// //     <Container className="body-cards mt-4">
// //       <Row>
// //         {/* Users Card */}
// //         <Col md={4} className="mb-4">
// //           <Card className="card-users"
// //             style={{ cursor: 'pointer' }}
// //             onClick={() => onNavigate('users')}
// //           >
// //             <Card.Header>
// //               <i className="fas fa-users icon"></i> Users
// //             </Card.Header>
// //             <Card.Body>
// //               <Card.Text className="card-value">Count: {userCount}</Card.Text>
// //             </Card.Body>
// //           </Card>
// //         </Col>
 
// //         {/* Devices Card */}
// //         <Col md={4} className="mb-4">
// //           <Card className="card-devices"
// //             style={{ cursor: 'pointer' }}
// //             onClick={() => onNavigate('devices')}
// //           >
// //             <Card.Header>
// //               <i className="fas fa-microchip icon"></i> Devices
// //             </Card.Header>
// //             <Card.Body>
// //               <Card.Text className="card-value">Count: {deviceCount}</Card.Text>
// //             </Card.Body>
// //           </Card>
// //         </Col>
 
// //         {/* Alerts Card */}
// //         {/* <Col md={4} className="mb-4">
// //           <Card className="card-alerts">
// //             <Card.Header>
// //               <i className="fas fa-bell icon"></i> Fall Alerts
// //             </Card.Header>
// //             <Card.Body>
// //               <Card.Text className="card-value">Count: {activeAlertsCount}</Card.Text>
// //             </Card.Body>
// //           </Card>
// //         </Col> */}
 
// //         {/* Admins Card */}
// //         <Col md={4} className="mb-4">
// //           <Card className="card-admins"
// //             style={{ cursor: 'pointer' }}
// //             onClick={() => onNavigate('admins')}
// //           >
// //             <Card.Header>
// //               <i className="fas fa-user-shield icon"></i> Admins
// //             </Card.Header>
// //             <Card.Body>
// //               <Card.Text className="card-value">Count: {adminCount}</Card.Text>
// //             </Card.Body>
// //           </Card>
// //         </Col>

// //         {/* Patients Card */}
// //         <Col md={4} className="mb-4">
// //           <Card className="card-patients"
// //             style={{ cursor: 'pointer' }}
// //             onClick={() => onNavigate('patients')}
// //           >
// //             <Card.Header>
// //               <i className="fas fa-user-injured icon"></i> Patients
// //             </Card.Header>
// //             <Card.Body>
// //               <Card.Text className="card-value">Count: {patientCount}</Card.Text>
// //             </Card.Body>
// //           </Card>
// //         </Col>

// //         {/* Patient Alerts Card */}
// //         <Col md={4} className="mb-4">
// //           <Card
// //             className="card-patient-alerts"
// //             style={{ cursor: 'pointer' }}
// //             onClick={() => onNavigate('admin-alerts')}
// //           >
// //             <Card.Header>
// //               <i className="fas fa-bell icon"></i> Patient Alerts
// //             </Card.Header>
// //             <Card.Body>
// //               <Card.Text className="card-value">
// //                 Count: {alertsLoading ? 'Loading...' : alerts.length}
// //               </Card.Text>
// //               {/* <Card.Text className="card-instruction">Click to view details</Card.Text> */}
// //             </Card.Body>
// //           </Card>
// //         </Col>
 
// //         {/* Patient Lookup Card */}
// //         <Col md={4} className="mb-4">
// //           <PatientLookup />
// //         </Col>
// //       </Row>
// //     </Container>
// //   );
// // };
 
// // export default AdminCards;


// import React, { useEffect } from 'react';
// import { Card, Container, Row, Col } from 'react-bootstrap';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchAllUsers } from '../../redux/slices/UsersSlice';
// import { fetchAllDevices } from '../../redux/slices/DeviceSlice';
// import { fetchAllAdmins } from '../../redux/slices/AdminSlice';
// import { fetchAllPatients } from '../../redux/slices/PatientSlice';
// import { fetchAllAlerts } from '../../redux/slices/AlertSlice';
// import PatientLookup from '../Admin/PatientLookup';

// const AdminCards = ({ onNavigate }) => {
//   const dispatch = useDispatch();

//   const { users } = useSelector((state) => state.users);
//   const { devices } = useSelector((state) => state.devices);
//   const { admins } = useSelector((state) => state.admins);
//   const { patients } = useSelector((state) => state.patients);
//   const { alerts, loading: alertsLoading } = useSelector((state) => state.alerts);

//   useEffect(() => {
//     dispatch(fetchAllUsers());
//     dispatch(fetchAllDevices());
//     dispatch(fetchAllAdmins());
//     dispatch(fetchAllPatients());
//     dispatch(fetchAllAlerts());
//   }, [dispatch]);

//   return (
//     <Container className="body-cards mt-4">
//       <Row className="g-4">
//         {/* Users Card */}
//         <Col md={4}>
//           <Card
//             className="card-users animated-card"
//             onClick={() => onNavigate('users')}
//           >
//             <div className="card-overlay" />
//             <Card.Header>
//               <i className="fas fa-users icon"></i> Users
//             </Card.Header>
//             <Card.Body>
//               <h2 className="card-value">{users.length}</h2>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Devices Card */}
//         <Col md={4}>
//           <Card
//             className="card-devices animated-card"
//             onClick={() => onNavigate('devices')}
//           >
//             <div className="card-overlay" />
//             <Card.Header>
//               <i className="fas fa-microchip icon"></i> Devices
//             </Card.Header>
//             <Card.Body>
//               <h2 className="card-value">{devices.length}</h2>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Admins Card */}
//         <Col md={4}>
//           <Card
//             className="card-admins animated-card"
//             onClick={() => onNavigate('admins')}
//           >
//             <div className="card-overlay" />
//             <Card.Header>
//               <i className="fas fa-user-shield icon"></i> Admins
//             </Card.Header>
//             <Card.Body>
//               <h2 className="card-value">{admins.length}</h2>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Patients Card */}
//         <Col md={4}>
//           <Card
//             className="card-patients animated-card"
//             onClick={() => onNavigate('patients')}
//           >
//             <div className="card-overlay" />
//             <Card.Header>
//               <i className="fas fa-user-injured icon"></i> Patients
//             </Card.Header>
//             <Card.Body>
//               <h2 className="card-value">{patients.length}</h2>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Patient Alerts Card */}
//         <Col md={4}>
//           <Card
//             className="card-patient-alerts animated-card"
//             onClick={() => onNavigate('admin-alerts')}
//           >
//             <div className="card-overlay" />
//             <Card.Header>
//               <i className="fas fa-bell icon"></i> Patient Alerts
//             </Card.Header>
//             <Card.Body>
//               <h2 className="card-value">
//                 {alertsLoading ? 'Loading...' : alerts.length}
//               </h2>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Patient Lookup Card */}
//         <Col md={4}>
//           <PatientLookup />
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default AdminCards;

import React, { useEffect } from 'react';
import { Card, Container, Row, Col, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAllUsers } from '../../redux/slices/UsersSlice';
import { fetchAllDevices } from '../../redux/slices/DeviceSlice';
import { fetchAllAdmins } from '../../redux/slices/AdminSlice';
import { fetchAllPatients } from '../../redux/slices/PatientSlice';
import { fetchAllAlerts } from '../../redux/slices/AlertSlice';
import { fetchAllFallAlerts } from '../../redux/slices/AlertTableSlice';  // ✅ CORRECT!
import PatientLookup from '../Admin/PatientLookup';

const AdminCards = ({ onNavigate }) => {
  const dispatch = useDispatch();

  const { users } = useSelector((state) => state.users);
  const { devices } = useSelector((state) => state.devices);
  const { admins } = useSelector((state) => state.admins);
  const { patients } = useSelector((state) => state.patients);
  const { alerts, loading: watchAlertsLoading } = useSelector((state) => state.alerts);
  const { alerts: fallAlerts, loading: fallAlertsLoading } = useSelector((state) => state.fallAlerts);

  useEffect(() => {
    dispatch(fetchAllUsers());
    dispatch(fetchAllDevices());
    dispatch(fetchAllAdmins());
    dispatch(fetchAllPatients());
    dispatch(fetchAllAlerts());           // Watch Alerts
    dispatch(fetchAllFallAlerts());       // Fall Alerts ✅
  }, [dispatch]);

  const watchAlertsCount = watchAlertsLoading ? 0 : alerts.length;
  const fallAlertsCount = fallAlertsLoading ? 0 : fallAlerts.length;

  return (
    <Container className="body-cards mt-4">
      <Row className="g-4">
        {/* Users Card */}
        <Col md={4}>
          <Card className="card-users animated-card" onClick={() => onNavigate('users')}>
            <div className="card-overlay" />
            <Card.Header><i className="fas fa-users icon"></i> Users</Card.Header>
            <Card.Body><h2 className="card-value">{users.length}</h2></Card.Body>
          </Card>
        </Col>

        {/* Devices Card */}
        <Col md={4}>
          <Card className="card-devices animated-card" onClick={() => onNavigate('devices')}>
            <div className="card-overlay" />
            <Card.Header><i className="fas fa-microchip icon"></i> Devices</Card.Header>
            <Card.Body><h2 className="card-value">{devices.length}</h2></Card.Body>
          </Card>
        </Col>

        {/* Admins Card */}
        <Col md={4}>
          <Card className="card-admins animated-card" onClick={() => onNavigate('admins')}>
            <div className="card-overlay" />
            <Card.Header><i className="fas fa-user-shield icon"></i> Admins</Card.Header>
            <Card.Body><h2 className="card-value">{admins.length}</h2></Card.Body>
          </Card>
        </Col>

        {/* Patients Card */}
        <Col md={4}>
          <Card className="card-patients animated-card" onClick={() => onNavigate('patients')}>
            <div className="card-overlay" />
            <Card.Header><i className="fas fa-user-injured icon"></i> Patients</Card.Header>
            <Card.Body><h2 className="card-value">{patients.length}</h2></Card.Body>
          </Card>
        </Col>

        {/* ✅ FIXED Alerts Card */}
        {/* <Col md={4}>
          <Card className="card-patient-alerts animated-card">
            <div className="card-overlay" />
            <Card.Header>
              <i className="fas fa-bell icon"></i> Alerts
            </Card.Header>
            <Card.Body className="text-center p-3">
              <Button
                  variant="outline-primary"
                  size="sm"
                  className="alert-btn mb-1 w-100"  // Reduced margin
                  onClick={() => onNavigate('watch-alerts')}
                >
                  <i className="fas fa-eye me-1" style={{fontSize: '12px'}}></i>
                  Watch: {watchAlertsCount}
                </Button>

                <Button
                  variant="primary"
                  size="sm" 
                  className="alert-btn w-100"    // No margin
                  onClick={() => onNavigate('fall-alerts')}
                >
                  <i className="fas fa-exclamation-triangle me-1" style={{fontSize: '12px'}}></i>
                  Falls: {fallAlertsCount}
                </Button>
            </Card.Body>
          </Card>
        </Col> */}
        <Col md={4}>
          <Card className="card-patient-alerts animated-card">
            <div className="card-overlay" />

            <Card.Header>
              <i className="fas fa-bell icon"></i> Patient Alerts
            </Card.Header>

            <Card.Body className="text-center p-3">
              <Button
                variant="primary"
                size="sm"
                className="alert-btn w-100"
                onClick={() => onNavigate("fall-alerts")}
              >
                <i
                  className="fas fa-exclamation-circle me-1"
                  style={{ fontSize: "12px" }}
                ></i>

                Alerts: {watchAlertsCount}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Patient Lookup Card */}
        <Col md={4}>
          <PatientLookup />
        </Col>
      </Row>
    </Container>
  );
};

export default AdminCards;